import React, { useContext, useEffect, useState, useRef } from "react";
import PageName from "../Utils/PageName";
import { Link, useLocation } from "react-router-dom";
import { environmentVariables } from "../../config/env.config";
import axios from "axios";
import { userContext } from "../../context/userContext";
import ReactDOM from "react-dom";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { businessContext } from "../../context/businessContext";
import { businessObjContext } from "../../context/businessObjContext";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { businessNameContext } from "../../context/businessContext";
import FilterIcon from "../../../src/Images/FilterIcon.png";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import { ToastContainer, toast } from "react-toastify";
import Modal from "@mui/material/Modal";
import { Box } from "@mui/material";
import "./UpdateRequestcardstyle.css";
import { useCallback, useMemo } from "react";
import { format } from 'date-fns';
import { useTranslation } from "react-i18next";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import moment from "moment";
import { getUserPermission } from "../../utils/utility";
import "../SuperAdmin/CustomPaymentHistoryStyle.css";

const Restaurantorders = ({dineIn}) => {
  const { t } = useTranslation();
  const location = useLocation()
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const baseUrl = environmentVariables?.apiUrl;
  const { userData, setUserData } = useContext(userContext);

  const { businessObjData, setBusinessObjData } =
    useContext(businessObjContext);
  const [isLoading, setIsLoading] = useState(true);
  const { businessNameData, setBusinessNameData } =
    useContext(businessNameContext);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("");
  const [isTable, setIsTable] = useState(false);
  const [initialPaymentStatus, setInitialPaymentStatus] = useState(null);
  const [initialOrderStatus, setInitialOrderStatus] = useState(null);
  const [hasSavedPayment, setHasSavedPayment] = useState(false);
  const [hasSavedOrder, setHasSavedOrder] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  // const [showModal, setShowModal] = useState(false);
  const [orderId, setOrderId] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [contactNoCountryCode, setContactNoCountryCode] = useState("");

  const [businessname, setBusinessname] = useState("");
  const [businessData, setBusinessData] = useState([]);
  const [tempData, setTempData] = useState([]);
  const tableExtensions = { export: false, print: false };
  const [isSubmit, setIsSubmit] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const fromDate = useRef(null);
  const toDate = useRef(null);
  const [action] = useState({ fromUser: false });
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [paginationPerPage, setPaginationPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState([]);
  const [activeBusinessName, setActiveBusinessName] = useState("");
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const closeButtonRef = useRef(null);
  const [searchId, setSearchId] = useState("");
  const abortController = new AbortController();
  const storedUserData = localStorage.getItem("user");
  const userDataObject = JSON.parse(storedUserData);

  const items = typeof selectedMessage?.items === 'string' ? JSON.parse(selectedMessage.items) : selectedMessage?.items;


  const handleFilterOpen = () => {
    setShowFilter(!showFilter);
  };
  const handleFilterClose = () => {
    setShowFilter(false);
  };


  const [orders, setOrders] = useState([]);

  const fetchOrders = async (page) => {
    try {
      const response = await axios.get(`${baseUrl}api/v1/business/fetchOrdersByUserId`, {
        headers: {
          _token: userData?.token,
        },
        params: {
          userId: userData.id,
          page: page,
          pageSize: rowsPerPage,
          searchId: searchId,
          dinein : dineIn
        }
      });
      setOrders(response.data.orders);
      setPaginationTotalRows(response?.data?.orders?.count)
      setIsLoading(false);
      setData(response?.data?.orders?.rows)
    } catch (error) {
      console.error('Error fetching orders:', error);
      setIsLoading(false);
    }
  };


   function useWindowWidth() {
      const [width, setWidth] = useState(window.innerWidth);
      useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
      return width;
    }
  
    const windowWidth = useWindowWidth();


  const Boxstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    // height: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    zIndex: 999,
    borderRadius: "15px",
    border: "none",
    outline: "none",
    focus: "none",
    boxShadow:
      " rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;",
    padding: "3rem 5rem",
    "@media (max-width: 650px)": {
      width: "425px",
      padding: "2rem",
    },
    "@media (max-width: 430px)": {
      width: "380px",
      padding: "2rem",
    },
    "@media (max-width: 390px)": {
      width: "350px",
      padding: "2rem",
    },
  };

  const customStyles = {
    dataTableExtensions: {
      backgroundColor: "lightgray",
      padding: "10px",
    },
    headRow: {
      style: {
        backgroundColor: "#e9e9e9",
        borderRadius: "2px 2px 0 0",
        paddingLeft: "25px",
        border: "none",
        textTransform: "capitalize",
        position: "sticky",
        left: 0,
        top: 0,
        zIndex: 1,
        boxShadow: "0 2px 2px -1px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        whiteSpace: "nowrap",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px",
        minHeight: "52px",
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px",
        fontSize: "14px",
        textTransform: "capitalize",
        minHeight: "48px !important",
      },
    },
    BusinessColumn: {
      position: "sticky",
      left: "0",
      zIndex: "1",
      backgroundColor: "#fff",
      overflow: "hidden",
      whiteSpace: "nowrap",
    }
  };



  const handleOnSelectedRowsChange = useCallback(
    ({ selectedRows }) => {
      if (!action.fromUser) return; 

      selectedRowsPerPage[currentPage] = selectedRows;
    },
    [currentPage, selectedRowsPerPage, action.fromUser]
  );

  const handlePageChange = (page) => {
    const nextPage = page;
    fetchOrders(nextPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); 
    setSelectedRowsPerPage([]);
    fetchOrders(1);
  };

  useEffect(() => {
    fetchOrders();
    return () => {
      abortController.abort();
    };
  }, [rowsPerPage,searchId , dineIn]);

  useEffect(() => {
    fetchOrders();
  }, [businessObjData]);

    useEffect(() => {
      setActiveBusinessName("")
      setSearchId("")
    },[location?.pathname])


  const hideModal = () => {
    if (closeButtonRef.current) {
        closeButtonRef.current.click();
    }
    setOpen(false);
};

  const handleToggleStatus = () => { };
  const fetchData = async (obj) => {
    (obj?.table_no == null || obj?.table_no == "") ? setIsTable(false) : setIsTable(true);
    try {      
      setInitialPaymentStatus(obj?.payment_status);
      setInitialOrderStatus(JSON.parse(obj?.status));
      setHasSavedPayment(false);
      setHasSavedOrder(false);
      setOrderId(obj.orderId);
      setBusinessname(obj.BusinessName)
      setSelectedOption(JSON.parse(obj?.status));
      setSelectedPaymentOption(obj?.payment_status);
      setContactNo(obj.phone)
      setContactNoCountryCode(obj.countryCode)
    } catch (error) {
      console.error("API Error:", error);
    }
  };
 

const columns = [
  {
    name: t("OrderId"),
    selector: (row) => row?.orderId || "--",
    sortable: true,
    cell: (row) => (
      <div className="custom-cell order-id-cell custom-cell-bold" data-column-name={t("OrderId")}>
        {row?.orderId || "--"}
      </div>
    ),
    minWidth: "180px",
  },
  {
    name: t("Restaurant_name"),
    selector: (row) => row?.BusinessName || "--",
    sortable: true,
    cell: (row) => (
      <div className="custom-cell custom-cell-bold" data-column-name={t("Restaurant_name")}>
        {row?.BusinessName || "--"}
      </div>
    ),
    minWidth: "200px",
  },
  {
    name: t("Table_no"),
    selector: (row) => row?.table_no || "--",
    sortable: true,
    cell: (row) => (
      <div className="custom-cell custom-cell-bold" data-column-name={t("Table_no")}>
        {row?.table_no || "--"}
      </div>
    ),
    minWidth: "120px",
    omit: !dineIn,
  },
  {
    name: t("Total_amount"),
    selector: row => {
        const currency = row?.currency || "";
        const amount =  row?.totalAmount || "--";
        if (amount == null) return "--";

        if (currency === "AED" || currency === "د.") {
          return `${amount} ${currency}`;
        } else {
          return `${currency}${amount}`;
        }
      },
    sortable: true,
    minWidth: "160px",
  },
  {
    name: t("Date"),
    selector: (row) => {
      const date = new Date(row?.createdAt);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    sortable: true,
    cell: (row) => {
      const date = new Date(row?.createdAt);
      const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
      return (
        <div className="custom-cell custom-cell-bold" data-column-name={t("Date")}>
          {formattedDate}
        </div>
      );
    },
    minWidth: "115px",
  },
  {
    name: t("Customer_name"),
    selector: (row) => row?.username || "--",
    sortable: true,
    cell: (row) => (
      <div className="custom-cell custom-cell-bold" data-column-name={t("Customer_name")}>
        {row?.username || "--"}
      </div>
    ),
    minWidth: "180px",
  },
  {
    name: t("Phone"),
    selector: (row) => ((row?.countryCode || "") + " " + (row?.phone || "")) || "--",
    sortable: true,
    cell: (row) => (
      <div className="custom-cell custom-cell-bold" data-column-name={t("Phone")}>
        {`${row?.countryCode || ""} ${row?.phone || ""}`.trim() || "--"}
      </div>
    ),
    minWidth: "130px",
  },
  {
    name: t("Address"),
    selector: (row) => row?.address || "--",
    sortable: true,
    cell: (row) => (
      <div className="custom-cell custom-cell-bold" data-column-name={t("Address")}>
        {row?.address || "--"}
      </div>
    ),
    minWidth: "220px",
  },
  {
    name: t("Order_status"),
    selector: (row) => row?.status || "--",
    sortable: true,
    cell: (row) => {
      const status = row?.status?.replace(/"/g, '') || "--";
      const capitalizedStatus = status.charAt(0).toUpperCase() + status.slice(1);
      return (
        <div className="custom-cell custom-cell-bold" data-column-name={t("Order_status")}>
          {capitalizedStatus}
        </div>
      );
    },
    minWidth: "150px",
  },
  {
    name: t("Payment_status"),
    selector: (row) => row?.payment_status || "--",
    sortable: true,
    cell: (row) => {
      const status = row?.payment_status?.replace(/"/g, '') || "--";
      const displayStatus = status === 'Transaction_not_paid_yet' ? "Unpaid" : status;
      const capitalizedStatus = displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1);
      return (
        <div className="custom-cell custom-cell-bold" data-column-name={t("Payment_status")}>
          <span style={{}}>{capitalizedStatus}</span>
        </div>
      );
    },
    minWidth: "150px",
  },
  {
    name: t("Action"),
    sortable: false,
    cell: (row) => {
      const isBO = userDataObject?.created_by == 0;
      const hasPermission = getUserPermission(userDataObject, 121);
      const hasViewPermission = getUserPermission(userDataObject, 120);
      return (
        <div style={{ display: "block",flexDirection:"column", justifyContent: "space-between", width:"100%" }}>
        <div className="custom-cell custom-cell-bold" data-column-name={t("Action")}>
          {(isBO || hasPermission) && (
            <i
              key={row?.orderId}
              data-bs-toggle="modal"
              data-bs-target="#planselect"
              onClick={() => fetchData(row)}
              className="first fas fa-pen"
              style={{ marginRight: "10px", cursor: "pointer" }}
            ></i>
          )}
          
        </div>
        <div>
        {(isBO || hasViewPermission) && (
            windowWidth > 768 ? (
              <i
                className="first fas fa-eye"
                onClick={() => handleViewMessage(row)}
                style={{ cursor: "pointer" }}
              ></i>
            ) : (
              <p
                onClick={() => handleViewMessage(row)}
                style={{
                  textDecoration: "underline",
                  width: "100%",
                  textAlign: "right",
                  fontSize: "14px",
                  cursor: "pointer"
                }}
              >
                View Details
              </p>
            )
          )}
          </div>
        </div>
      );
    },
    minWidth: "180px",
  }
];


  const handleViewMessage = (d) => {
    setOpen(true);
    setSelectedMessage(d);
  };

  const tableData = {
    columns,
    data,
  };
  const handleUpdate = () => { };
  const [editedData, setEditedData] = useState({
    date: new Date(),
  });
  const handleDateChange = (date) => {
    setEditedData({
      ...editedData,
      date: date,
    });
  };
  const handleDropdownChange = (e) => {
    if (e.target.value == "pending") {
      setSelectedOption(e.target.value);
    } else if (e.target.value == "Delivered") {
      setSelectedOption(e.target.value);
    } else if (e.target.value == "confirm") {
      setSelectedOption(e.target.value);
    } else if (e.target.value == "cancel") {
      setSelectedOption(e.target.value);
    }
  };

  const handlePaymentDropdown = (e) => setSelectedPaymentOption(e.target.value);

  const handleSubmit = (e) => {
    setIsSubmit(true);
    let obj = {
      orderId,
      businessname,
      selectedOption,
    };
    if (isTable) {
      obj.selectedPaymentOption = selectedPaymentOption;
    }
    axios
      .put(`${baseUrl}api/v1/business/updateorderstatus`, obj, {
        headers: {
          _token: userData?.token,
        },
        withCredentials: true,
      })
      .then((response) => {

        toast.success(t("Order_status_updated"), {
          position: toast.POSITION.TOP_RIGHT,
        });
        whatsappclick()
        fetchOrders()
        setIsSubmit(false);
      })
      .catch((error) => {
        console.log(error, "Appointment response");
        setIsSubmit(false);
      });
  };

  const whatsappclick = () => {
    const phoneNumber = contactNoCountryCode+contactNo;
    // const phoneNumber = "8929099255";
    let messageBody = '';

    switch (selectedOption) {
      case "confirm":
        messageBody = `Dear User, 
Your order has been confirmed.`;
        break;
      case "cancel":
        messageBody = `Dear User, 
Your order has been canceled.
We apologize for any inconvenience caused.`;
        break;
      case "Delivered":
        messageBody = `Dear User, 
Your order has been delivered.`;
        break;
      default:
        messageBody = "Your order status has been updated.";
    }
    const message = encodeURIComponent(messageBody);

    const apiUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
    window.open(apiUrl, '_blank');

  };

  const handleChangeBusinessData = (e) => {
    setActiveBusinessName(e.target.value);
  };


  useEffect(() => {
    if (selectedDateTo != "" && selectedDateFrom != "") {
      if (selectedDateTo < selectedDateFrom) {
        warning(t("To_date_equal"), {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
    }
    const filters = {
      businessId: activeBusinessName === "All Business" ? null : activeBusinessName,
      startDate: selectedDateFrom,
      endDate: selectedDateTo,
    };
    fetchOrders(1, filters);
  }, [activeBusinessName, selectedDateFrom, selectedDateTo]);

  const handleSearch = () => {
    loadPageFilter()
    setShowFilter(false);
  };

  const loadPageFilter = () => {
    const nextPage = 1
    setCurrentPage(nextPage);
    fetchOrders(nextPage)
  };
 const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: true,
    selectAllRowsItemText: t("All"),
  };
  
  return (
    <div id="custom_table">
      <PageName PageName={t("Restaurant_orders")} />
      <article >
        <div className="row d-none">
          <div className="col-md-12">
            <div className="tile">
              <div className="tile-body">
                <form className="row">
                  <div className="mb-2 col-md-3">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Search....."
                    />
                  </div>
                  <div className="mb-2 col-md-3">
                    <select className="form-select">
                      <option value="">Select an option</option>
                      <option value="option1">xxx </option>
                      <option value="option2">xxxx</option>
                    </select>
                  </div>
                  <div className="mb-2 col-md-4 align-self-end">
                    <button className="btn btn-primary me-3" type="button">
                      <i className="bi bi-check-circle-fill ms-2 "></i>Search
                    </button>
                    <button className="btn btn-danger" type="button">
                      <i className="bi bi-check-circle-fill me-2"></i>Reset
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div className="main">
          {isLoading ? (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "55%",
                display: "flex",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <CircularLoader size={40} />
            </div>
          ) : (

            <>
              <div className="" style={{ position: 'relative', top: '-64px', width: '70%', left: '20px' }}>

              </div>

              <div className="filter-button-wrapper requestcardfilterbuttonWrapper">
                <span class="FilterIconTextWrapper" onClick={handleFilterOpen}>
                  {" "}
                  <div className="FilterIcon">
                    {" "}
                    <img loading="lazy" src={FilterIcon} width={28} />
                    <div className="filtertext">Filters</div>
                  </div>
                </span>
              
              </div>
              <Modal
                open={showFilter}
                onClose={handleFilterClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={Boxstyle}>
                  {showFilter && (
                    <div className="Contact_filter_fieldbutton_wrapper ModalPopupContainer">
                      <div className="Contact_filter_field_wrapper ModalPopupWrapper">
                        <div className="col-md-2 Contact_filter_Inputfield" id="ModalSelectfield">
                          <select
                            value={activeBusinessName}
                            onChange={(e) => handleChangeBusinessData(e)}
                            className="form-select"
                          >
                            {" "}
                            <option value={"All Business"}>All Business</option>
                            {businessData &&
                              businessData.map((val, index) => (
                                <option value={val}>{val} </option>
                              ))}
                          </select>
                          <div
                            style={{
                              fontSize: "14px",
                              color: "red",
                              bottom: "70px",
                            }}
                          ></div>
                        </div>


                        <div className="col-md-2 Contact_filter_Inputfield" id="ModalSelectfield">
                          <div className="dateiconmain">
                            <DatePicker
                              placeholderText="From date"
                              selected={selectedDateFrom}
                              onChange={(date) => setSelectedDateFrom(date)}
                              className="form-control"
                              ref={fromDate}
                              dateFormat="dd/MM/yyyy"
                              popperPlacement="bottom-end"
                            />
                            <div
                              className="contact_filter_toDate_calander_icon"
                              onClick={() => fromDate.current.setOpen(true)}
                            >
                              <i className="fa-regular fa-calendar"></i>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-2 Contact_filter_Inputfield" id="ModalSelectfield">
                          <div className="dateiconmain">
                            <DatePicker
                              placeholderText="To Date"
                              selected={selectedDateTo}
                              onChange={(date) => setSelectedDateTo(date)}
                              className="form-control"
                              ref={toDate}
                              dateFormat="dd/MM/yyyy"
                              popperPlacement="bottom-end"
                            />
                            <div
                              className="contact_filter_toDate_calander_icon"
                              onClick={() => toDate.current.setOpen(true)}
                            >
                              <i className="fa-regular fa-calendar"></i>
                            </div>
                          </div>
                        </div>
                        <div className="contact_filter_buttonwrapper">

                          <button
                            className="contact_filter_buttonstyle"
                            onClick={() => handleReset()}
                          >
                            Reset{" "}
                          </button>
                          <button
                            class="contact_filter_buttonstyle"
                            onClick={() => handleSearch()}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </Box>
              </Modal>

              <div class="user-select-items">
            <input type="text" onChange={(e)=>setSearchId(e.target.value)} value={searchId} placeholder="OrderId"/>
          </div>
              <div className="scrollable-columns">
                <div className="sticky-header-container">
                  <DataTableExtensions
                    {...tableData}
                    {...tableExtensions}
                    customStyles={customStyles}
                    filterPlaceholder="Search Orders"
                  >
                    <DataTable
                      columns={columns}
                      data={data}
                      noHeader
                      defaultSortField="id"
                      sortIcon={<SortIcon />}
                      defaultSortAsc={true}
                      pagination
                      highlightOnHover
                      paginationServer
                      paginationTotalRows={paginationTotalRows}
                      paginationPerPage={paginationPerPage}
                      paginationRowsPerPageOptions={[10, 20, 50, 100, 300, 1000, 10000]} // Customize as needed
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handleRowsPerPageChange}
                      onSelectedRowsChange={handleOnSelectedRowsChange}
                      dense
                       paginationComponentOptions={{
                        ...paginationOptions,
                      }}
                      customStyles={customStyles}
                      noDataComponent={<div style={{padding:"24px"}}>{t("No_records_found")}</div>}
                    />
                  </DataTableExtensions>
                </div>
              </div>
            </>
          )}
        </div>
      </article>
      <div
        className="modal fade"
        id="planselect"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content EditStatus_form">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {t("Update_status")}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleUpdate}>
                <div className="row g-3 mb-3">
                  <div className="col d-none">
                    <textarea
                      className="form-control"
                      placeholder="Enter Remarks"
                      aria-label="Name"
                    ></textarea>
                  </div>
                  <div className="col">
                  <div className="col">
                    <label htmlFor="type" className="form-label" style={{fontSize:"14px"}}>
                      {t("Order_status")}
                    </label>
                    <select
                      name="type"
                      className="form-select register_inputfield"
                      value={selectedOption}
                      onChange={handleDropdownChange}
                    >
                      <option
                        disabled={
                          initialOrderStatus === "confirm" || 
                          initialOrderStatus === "cancel" ||
                          initialOrderStatus === "Delivered" ||
                          (hasSavedOrder && selectedOption !== "pending")
                        }
                        value="pending">
                          {t("Pending")}
                      </option>
                      <option disabled={initialOrderStatus === "Delivered" || initialOrderStatus === "cancel"} value="confirm">{t("Confirm")} </option>
                      <option disabled={initialOrderStatus === "Delivered"} value="cancel">{t("Cancel")}</option>
                      <option disabled={initialOrderStatus === "cancel"} value="Delivered">{t("Delivered")} </option>
                    </select>
                  </div>
                  {isTable && (
                    <div className="col payment-update" style={{marginTop:"10px"}}>
                    <label htmlFor="type" className="form-label" style={{fontSize:"14px"}}>
                      {t("Payment_status")}
                    </label>
                    <select
                      name="type"
                      className="form-select register_inputfield"
                      value={selectedPaymentOption}
                      onChange={handlePaymentDropdown}
                    >
                      <option
                        disabled={
                          initialPaymentStatus === "complete" || 
                          initialPaymentStatus === "failed" ||
                          (hasSavedPayment && selectedPaymentOption !== "pending")
                        }
                        value="pending">
                          {t("Pending")}
                      </option>
                      <option value="complete">{t("Complete")} </option>
                    </select>
                  </div>
                  )}
                  </div>
                  <div className="col d-none">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Plan Name"
                      aria-label="Name"
                      name="txn_id"
                      onChange={(e) => console.log("w")}
                    />
                  </div>
                </div>
                <div class="ChangesEditform">
                  <button
                    type="button"
                    className="btn btn-primary save-cta"
                    data-bs-dismiss="modal"
                    onClick={(e) => handleSubmit(e)}
                  >
                    {isSubmit ? <CircularLoader size={20} /> : t("Save_changes")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

          <Modal
              aria-labelledby="modal-title"
              aria-describedby="modal-desc"
              open={open}
              onClose={() => hideModal()}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Sheet
                variant="outlined"
                sx={{
                  maxWidth: 500,
                  minWidth:390,
                  borderRadius: "md",
                  p: 3,
                  boxShadow: "lg",
                }}
                className="Infproductdetails"
              >
               <ModalClose 
                    ref={closeButtonRef} 
                    variant="plain" 
                    sx={{ m: 1 }} 
                    onClick={hideModal} 
                />
                <Typography
                  component="h2"
                  id="modal-title"
                  level="h4"
                  textColor="inherit"
                  fontWeight="lg"
                  mb={2}
                  textAlign="center"
                >
                  {t("Order_details")}
                </Typography>
                <div style={{display:"flex", justifyContent:"space-between"}}><span>{t("Order_id")}:</span> <span style={{fontWeight:"700"}}>#{selectedMessage?.orderId}</span></div>
                <div style={{display:"flex", justifyContent:"space-between"}}><span>{t("Order_date")}:</span> <span style={{fontWeight:"700"}}>{moment(selectedMessage?.created_at).format("DD-MMM-YYYY")}</span></div>
                <div style={{display:"flex", justifyContent:"space-between"}}><span>Amount To Pay :</span> <span style={{fontWeight:"700"}}>
                  {selectedMessage?.currency == "AED" ? (
                      <>
                      {selectedMessage?.totalAmount} {selectedMessage?.currency}
                      </>
                    ):(
                      <>
                      {selectedMessage?.currency}{selectedMessage?.totalAmount}
                      </>
                    )}</span></div>      
                {items && items.length > 0 && items.map((product, index) => (
                    <div key={index} className="product-container" style={{marginBottom:"20px", display:"flex", flexDirection:"column",marginTop:"20px"}}>
      
                        <div style={{display:"flex"}}>
                          <div className="product-info productinfodiv">
                            <img
                              src={`${environmentVariables?.s3UrlBackendUrl}${product?.image}`}
                              alt={product?.name}
                              className="item-image popupproductimg"
                            />
                          </div>
                          <div>
                            <div className="product-info productinfodiv">
                              <div className="modalcontentdiv">
                                {product?.name}
                              </div>
                            </div>
      
                            <div className="product-info productinfodiv">
                              <div className="modalcontentdiv">
                              {selectedMessage?.currency == "AED" ? (
                                <>
                                {product?.quantity} x {parseFloat(product?.price || 0).toFixed(2)} {selectedMessage?.currency}/ {product?.itemSize}
                                </>
                              ):(
                                <>
                              {product?.quantity} x {selectedMessage?.currency}{parseFloat(product?.price || 0).toFixed(2)}/ {product?.itemSize}
                                </>
                              )}
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                  ))}
      
                  <div>
                    <div><h4>{t("Shipping_address")}</h4></div>
                    <div>
                      <div>{t("Name")}: <strong>{selectedMessage?.username}</strong></div>
                      <div>{t("Phone")}: <strong>{selectedMessage?.countryCode} {selectedMessage?.phone}</strong></div>
                      {selectedMessage?.address && (
                        <div>
                          {t("Address")}: <strong>{selectedMessage.address}</strong>
                        </div>
                      )}
                    </div>
                  </div>
              </Sheet>
            </Modal>
    </div>
  );
};
export default Restaurantorders;
